var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:currentColor;stroke-width:5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.88,45.14H53.04c-0.79,0-1.43-0.64-1.43-1.43v-19.8c0-0.79,0.64-1.43,1.43-1.43h91.85 c0.79,0,1.43,0.64,1.43,1.43v19.8C146.31,44.51,145.67,45.14,144.88,45.14z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.62,
    y: 9,
    className: "st0",
    width: 68.19,
    height: 22.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.51,190.45H25.85c-0.68,0-1.23-0.55-1.23-1.23V10.23c0-0.68,0.55-1.23,1.23-1.23h147.66 c0.68,0,1.23,0.55,1.23,1.23v178.99C174.74,189.9,174.19,190.45,173.51,190.45z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 51.61,
    y1: 146.83,
    x2: 76.43,
    y2: 146.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 91.37,
    y1: 145.39,
    x2: 146.31,
    y2: 145.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 51.61,
    y1: 163.7,
    x2: 146.31,
    y2: 163.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.46,95.45l-35.69-0.47c0-19.71,15.98-35.69,35.69-35.69V95.45z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 100.28,
    cy: 97.61,
    r: 30.12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportesIcon);
export default __webpack_public_path__ + "static/media/reportesIcon.490db914d3fd70fe77f0b0a71b5c6a65.svg";
export { ForwardRef as ReactComponent };